export async function fetchQuestionSet(
  debatlabURL,
  questionSetID,
  { returnDummyData = false } = {},
) {
  if (returnDummyData) return await import("./question_set.json");

  const response = await fetch(
    `${debatlabURL}/question_sets/${questionSetID}`,
    { headers: { accept: "application/json" } },
  );
  if (!response.ok) {
    throw Error(
      `Fetching question set returned status ${response.status} - ${response.statusText}`,
    );
  }

  return await response.json();
}
